import map from "lodash/map";
import { getCanEditCustomFieldData } from "PFApp/components/custom_values_edit_field/custom_values_edit_field.utils";
import { useSkillsType } from "PFCore/hooks";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { CustomType, Profile } from "PFCore/types";
import { useTranslation } from "react-i18next";

type UseCanApplySkillsFrameworkProps = {
  activityCreator: Profile | null;
};

export const useCanApplySkillsFramework = ({ activityCreator }: UseCanApplySkillsFrameworkProps) => {
  const { t: tTranslation } = useTranslation();
  const skillsType = useSkillsType();
  const { data: currentProfile } = useCurrentProfile();

  const canApplyChanges = (customFields) =>
    [skillsType, ...map(customFields, "type")].some(
      (customType: CustomType) =>
        !getCanEditCustomFieldData({
          customType,
          currentProfile,
          isActivity: true,
          activityCreator,
          t: tTranslation
        }).locked
    );

  return canApplyChanges;
};
